import React from "react";
import { useHistory } from "react-router";
import { PPRetakeQuizDialog } from "../PPQuizTaker/PPQuizRetakeDialog";
export const PPWatchVideoQuizButtons = ({
  ppQuizResultVOList = [],
  landingPageInfor,
  subtopictagid,
  video,
  isbn,
}) => {
  const history = useHistory();
  const navigateToPPQuiz = async (mode, isRetake = false) => {
    let instances = {};
    if (isRetake) {
      localStorage.removeItem("ppQuizInstances");
    }
    switch (mode) {
      case "p":
        if (!isRetake) {
          instances = filterQuizInstance("false");
          localStorage.setItem("ppQuizInstances", JSON.stringify(instances));
        }
        history.push(
          `/pp-quiz/practice/${isbn}/${subtopictagid}/${landingPageInfor.SATagId}/video`,
        );
        break;
      case "g":
        if (!isRetake) {
          instances = filterQuizInstance("true");
          localStorage.setItem("ppQuizInstances", JSON.stringify(instances));
        }
        history.push(
          `/pp-quiz/graded/${isbn}/${subtopictagid}/${landingPageInfor.SATagId}/video`,
        );
        break;
    }
  };
  const filterQuizInstance = (mode) => {
    let instances = ppQuizResultVOList.filter((quizInstance) => {
      if (quizInstance.isGraded == mode) {
        return quizInstance;
      }
    })[0];
    if (instances) {
      instances.customerFacingSubTopicName = video.customerFacingSubTopicName;
      instances.quizType = "video";
      instances.subTopicTagId = subtopictagid;
      instances.subjectAreaTagId = landingPageInfor.SATagId;
      instances.ProductName = landingPageInfor.ProductName;
    }
    return instances;
  };
  const handleViewResults = (instanceId) => {
    history.push(
      `/pp-quiz/results/${isbn}/${subtopictagid}/${landingPageInfor.SATagId}/${instanceId}`,
    );
  };
  const ButtonsForQuiz = () => {
    let practiceMode = (
      <button
        onClick={() => navigateToPPQuiz("p")}
        className="ppwvPracticeBtn mr-2"
      >
        Practice Mode
      </button>
    );
    let gradedMode = (
      <button
        onClick={() => navigateToPPQuiz("g")}
        className="ppwvGradeBtn rounded-0"
      >
        Graded Mode
      </button>
    );
    if (!ppQuizResultVOList.length) {
      return (
        <React.Fragment>
          {practiceMode}
          {gradedMode}
        </React.Fragment>
      );
    }
    for (let i = 0; i < ppQuizResultVOList.length; i++) {
      const { instanceId, instanceURL, isCompleted, isGraded, quizIdentifier } =
        ppQuizResultVOList[i];
      if (ppQuizResultVOList[i].isGraded == "true") {
        if (ppQuizResultVOList[i].isCompleted == "true") {
          gradedMode = (
            <div className="d-flex flex-column">
              <PPRetakeQuizDialog
                details={true}
                mode="Graded"
                video={video}
                onHandleRetakeQuizz={() => navigateToPPQuiz("g", true)}
              />
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleViewResults(instanceId);
                }}
                className="gradedResultLink ppwvResultText"
              >
                View Graded Results
              </a>
            </div>
          );
        } else {
          if (ppQuizResultVOList[i].instanceURL) {
            gradedMode = (
              <button
                onClick={() => navigateToPPQuiz("g")}
                className="ppwvGradeBtn rounded-0"
              >
                Continue Graded Mode
              </button>
            );
          } else {
            gradedMode = (
              <button
                onClick={() => navigateToPPQuiz("g")}
                className="ppwvGradeBtn rounded-0"
              >
                Graded Mode
              </button>
            );
          }
        }
      } else {
        if (ppQuizResultVOList[i].isCompleted == "true") {
          practiceMode = (
            <div className="d-flex flex-column">
              <PPRetakeQuizDialog
                mode="Practice"
                details={true}
                video={video}
                onHandleRetakeQuizz={() => navigateToPPQuiz("p", true)}
              />
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleViewResults(instanceId);
                }}
                className="practiceResultLink ppwvResultText"
              >
                View Practice Results
              </a>
            </div>
          );
        } else {
          if (ppQuizResultVOList[i].instanceURL) {
            practiceMode = (
              <React.Fragment>
                <button
                  onClick={() => navigateToPPQuiz("p")}
                  className="ppwvPracticeBtn mr-2"
                >
                  Continue Practice Mode
                </button>
              </React.Fragment>
            );
          } else {
            practiceMode = (
              <React.Fragment>
                <button
                  onClick={() => navigateToPPQuiz("p")}
                  className="ppwvPracticeBtn mr-2"
                >
                  Practice Mode
                </button>
              </React.Fragment>
            );
          }
        }
      }
    }
    return (
      <>
        {practiceMode}
        {gradedMode}
      </>
    );
  };
  return (
    <div
      className="d-flex flex-row align-content-start"
      style={{ gap: "0.5rem" }}
    >
      {ButtonsForQuiz()}
    </div>
  );
};
